export interface WhatsAppSession {
  id_whatsapp_session?: string;
  id_sesion?: string;
  id?: string;
  codigo: string;
  estado: boolean;
  phone: string | null;
  label: string | null;
  rol: string | null;
  rol_display?: string;
  status: "pending" | "qr" | "connecting" | "connected" | "disconnected" | "logged_out";
  status_display?: string;
  session_token: string | null;
  webhook_url: string | null;
  qr_code?: string | null;
  qr_data_url?: string | null;
  fecha_creacion?: string;
  fecha_modificacion?: string;
}

export interface WhatsAppSessionSerializerDocBody {
  codigo: string;
  estado?: boolean;
  phone?: string | null;
  label?: string | null;
  rol?: string | null;
  status?: string;
  session_token?: string | null;
  webhook_url?: string | null;
}

export interface ConnectSessionRequest {
  phone: string;
  label: string;
  rol: string;
}

export interface ConnectSessionResponse {
  mensaje?: string;
  ya_registrado?: boolean;
  sesion: WhatsAppSession;
  qr_data_url?: string;
}

export interface AssignChatRequest {
  id_chat: string;
  id_sesion: string;
}

export interface AssignContactoRequest {
  phone_contacto: string;
  id_sesion: string;
}

export interface EnviarMensajeRequest {
  id_sesion: string;
  phone_destino: string;
  texto: string;
}

export interface Chat {
  id_chat?: string;
  codigo: string;
  estado: boolean;
  jid: string | null;
  kind: "direct" | "group" | null;
  is_group: boolean | null;
  ultimo_mensaje?: string | null;
  sesion?: WhatsAppSession | string;
  sesion_id?: string;
  agente_asignado?: number | null;
  agente_detalle?: {
    id: number;
    username: string;
    nombre_completo: string;
  } | null;
  updated_at?: string;
  fecha_creacion?: string;
  fecha_modificacion?: string;
}

export interface Contacto {
  id_contacto?: string;
  codigo: string;
  estado: boolean;
  phone: string | null;
  jid: string | null;
  push_name: string | null;
  fecha_creacion?: string;
  fecha_modificacion?: string;
}

export interface Mensaje {
  id_mensaje?: string;
  codigo: string;
  estado: boolean;
  whatsapp_id: string | null;
  from_me: boolean | null;
  message_type: "text" | "image" | "video" | "document" | "audio" | null;
  text: string | null;
  media_url: string | null;
  media_mimetype: string | null;
  media_filename: string | null;
  status: "sent" | "delivered" | "read" | null;
  whatsapp_timestamp: string | null;
  chat: string | null;
  contacto: string | null;
  usuario: number | null;
  sesion?: string;
  sesion_id?: string;
  fecha_creacion?: string;
  fecha_modificacion?: string;
}

export type RolType = "support" | "deliveries" | "assistance" | "development" | "sales" | "other";

export const ROLES: { value: RolType | string; label: string; color: string }[] = [
  { value: "support", label: "Soporte", color: "#3b82f6" },
  { value: "deliveries", label: "Entregas", color: "#22c55e" },
  { value: "assistance", label: "Asistencia", color: "#a855f7" },
  { value: "development", label: "Desarrollo", color: "#f59e0b" },
  { value: "sales", label: "Ventas", color: "#ec4899" },
  { value: "marketing", label: "Marketing", color: "#f97316" },
  { value: "other", label: "Otro", color: "#64748b" },
];

export function getRolInfo(rol: string | null) {
  if (!rol) return { label: "Sin rol", color: "#64748b" };
  const found = ROLES.find(r => r.value === rol);
  return found || { label: rol, color: "#64748b" };
}

export const STATUS_COLORS: Record<string, string> = {
  connected: "#22c55e",
  qr: "#eab308",
  connecting: "#3b82f6",
  pending: "#64748b",
  disconnected: "#ef4444",
  logged_out: "#ef4444",
};

export const STATUS_LABELS: Record<string, string> = {
  connected: "Conectado",
  qr: "Escanea QR",
  connecting: "Conectando",
  pending: "Pendiente",
  disconnected: "Desconectado",
  logged_out: "Sesión cerrada",
};

// ========== ENVELOPE / WRAPPER TYPES ==========

export interface EnvelopeData<T> {
  code: number;
  status: string;
  message: string;
  data: T;
}

export interface PaginatedResults<T> {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

export interface ConnectionStatusResponse {
  conectado: boolean;
  total_sesiones: number;
  conectadas: number;
  pendientes: number;
  desconectadas: number;
  sesion_activa: WhatsAppSession | null;
  sesiones: WhatsAppSession[];
}

export interface SessionStatusResponse {
  sesion: WhatsAppSession;
  status_microservicio?: unknown;
}